<template>
  <div class="flex family">
    <div class="basic">
      <family-profile :family="family" :edit_id="edit_id"></family-profile>
    </div>
    <div class="m-AddBox">
      <family-students-index :family="family"></family-students-index>
    </div>
    <div class="m-support">
      <family-history :family="family" :condition="condition" :edit_id="edit_id" type="true"></family-history>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    family: Object,
    condition: Object,
    edit_id: Object
  },
  data () {
    return {
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.edit_id.family_id === this.family.id) {
      alert('家庭情報が編集中です')
      return
    } else if (this.condition.condition) {
      alert('対応履歴が編集中です')
      return
    } else if (this.edit_id.list_id) {
      alert('対応履歴が編集中です')
      return
    }
    next()
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang='scss'>
.flex {
  display: flex;
}
.family {
  &:after {
    content: "\f015";
    font-family: FontAwesome;
    position: absolute;
    font-size: 500px;
    top: 50%;
    left: 50%;
    margin-top: -250px;
    margin-left: -250px;
    color: #ddd;
    opacity: 0.1;
    z-index: -1;
  }
}
.basic {
  max-width: 33%;
  flex-basis: 33%;
}
.m-AddBox {
  max-width: 33%;
  flex-basis: 33%;
}
.m-support {
  max-width: 34%;
  flex-basis: 34%;
}
</style>



// WEBPACK FOOTER //
// FamilyIndex.vue?e7dc4eba